import React, { useEffect, useState } from 'react';
import { array, func, number, object } from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import { get } from 'lodash';

import queryString from 'query-string';
import template from 'url-template';

import { fetchBasAgent } from '../../actions/basAgentActions';
import EsmsPage from '../../components/EsmsPage';
import SidebarPanel from '../../components/SidebarPanel';

import classes from './ViewAgentLogsPage.module.css';
import useSelectedAgent from '../../hooks/useSelectedAgent';
import useApi from '../../hooks/useApi';
import { InputLabel, FormControl, MenuItem, Select } from '@material-ui/core';

const ViewAgentLogsPage = ({
    agent,
    companyInfo,
    fetchBasAgent,
    handleNetworkError,
    history,
    location,
    selectedInventoryIds,
    treeCacheId
}) => {
    const elasticSearchUrl = template.parse('/basagents/logs{?CompanyId,SearchObjectType,SerialNumber,LogGroup,Limit}');

    const search = new URLSearchParams(location.search);
    const queryValues = queryString.parse(history.location.search);

    const {
        selectedAgent
    } = useSelectedAgent(search.get('basAgent'));

    const DEFAULT_LIMIT = 40;

    const [logGroups, getLogGroups] = useApi(({ SerialNumber }) => ({
        url: elasticSearchUrl.expand({
            CompanyId:        companyInfo.companyId,
            Limit:            DEFAULT_LIMIT,
            SearchObjectType: 'LogGroups',
            SerialNumber
        })
    }));

    const [logs, getLogs] = useApi((params) => ({
        url: elasticSearchUrl.expand({
            CompanyId:        companyInfo.companyId,
            Limit:            '150',
            SearchObjectType: 'AgentLogs',
            ...params
        })
    }));

    useEffect(() => {
        if (!selectedAgent) {
            return;
        }
        getLogGroups({ SerialNumber: selectedAgent.serialNumber });
    }, [selectedAgent]);

    const [group, setGroup] = useState('');

    function handleSelectLogGroup(e) {
        const logGroup = e.target.value;
        setGroup(logGroup);
        getLogs({ LogGroup: logGroup, SerialNumber: selectedAgent.serialNumber });
    }

    function handleIotHubRoute() {
        history.push(`/iothub?company=${queryValues.company}`);
    }

    function handleSelectedAgentRoute() {
        history.push(`/iothub/basagents/manage?company=${queryValues.company}&basAgent=${selectedAgent.id}`);
    }

    const headerControl = () => {
        const id = get(selectedAgent, 'id', null);

        if (!selectedAgent || !id) return null;

        return (
            <Link to={`/iothub/basagents/manage/logs/advanced?company=${queryValues.company}&basAgent=${selectedAgent.id}`}>Try the new design!</Link>
        );
    };

    if (!selectedAgent) {
        return null;
    }

    return (
        <EsmsPage
            parents={[
                companyInfo.companyName,
                'BAS Agents',
                selectedAgent.name
            ]}
            handlers={[handleIotHubRoute, handleIotHubRoute, handleSelectedAgentRoute]}
            headerControl={process.env.advancedLogs ? headerControl : null}
            title="View Logs"
            sidebar={(
                <SidebarPanel
                    title="Agent Logs"
                    titleIconSrc="/assets/images/basAgentIconColor.svg"
                >
                    <FormControl>
                        <InputLabel>
                            Log Groups
                        </InputLabel>
                        <Select
                            value={group}
                            onChange={handleSelectLogGroup}
                        >
                            {
                                (logGroups.data || []).map((logGroup, index) =>
                                    <MenuItem
                                        key={index}
                                        value={logGroup}
                                    >
                                        {logGroup}
                                    </MenuItem>
                                )
                            }
                        </Select>
                    </FormControl>
                </SidebarPanel>)}
        >
            <div className={classes.agentEventLog}>
                <ul>
                    {Array.isArray(logs.data) ?
                        (logs.data || []).map((log, index) =>
                            <li className={classes.logText} key={index}>{log.message}</li>
                        )
                        : <li className={classes.logText}> {logs.data} </li>
                    }
                </ul>
            </div>
        </EsmsPage>
    );
};

ViewAgentLogsPage.defaultProps = {
    fetchBasAgent:      () => {},
    handleNetworkError: () => {}
};

ViewAgentLogsPage.propTypes = {
    companyInfo:          object,
    fetchBasAgent:        func,
    handleNetworkError:   func,
    inventory:            object,
    patchItem:            func,
    selectedInventoryIds: array,
    treeCacheId:          number.isRequired
};

export const mapStateToProps = ({ basAgent, companyInfo, inventory, selectedInventoryIds }) => {
    const {
        treeCacheId
    } = inventory;
    return {
        companyInfo,
        selectedInventoryIds,
        treeCacheId
    };
};

const mapDispatchToProps = {
    fetchBasAgent
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ViewAgentLogsPage));
